import { Breadcrumbs, IconButton, Theme, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import KenColors from '../../Helpers/Themes/kenColors';
import { getStudentInfo } from "../../Utils/apiService";
import KenLoader from '../../GlobalComponents/KenLoader';
import { getUserDetails } from "../../storageService";
import routes from '../../Utils/routes';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { AuthUser } from '../../interfaces/Contexts';

const useStyles = makeStyles((theme: Theme) => ({
  mainText: {
    fontWeight: '600 !important',
    textDecoration: 'none',
    textTransform: 'capitalize',
    margin: '0px !important',
    padding: '0px !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '13px !important',
    },
  },
  listText: {
    textDecoration: 'none',
    textTransform: 'capitalize',
    margin: '0px !important',
    padding: '0px !important',
  },
}));

const AppBreadCrumbs: React.FunctionComponent = () => {
  const { pathname, state } = useLocation();
  console.log("Current Path:", pathname);
  const {
    state: { user },
    dispatch,
  } = useContext(AuthContext);
  console.log("User from AuthContext:", user);
  const userData:any = user as AuthUser;
  const classes = useStyles();
  const [studentInfo, setStudentInfo] = useState({
    fullName: ""
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const userDetails = getUserDetails();
    if (userDetails?.ContactId) {
      getStudentInfo(userDetails.ContactId)
        .then((data) => {
          setStudentInfo({
            fullName: `${data?.firstName} ${data?.lastName}`,
          });
        })
        .catch(() => setError("Failed to load student details."))
        .finally(() => setLoading(false));
    }
  }, []);

  if (loading) return <KenLoader />;
  if (error) return <Typography color="error">{error}</Typography>;

  const rawPath = decodeURIComponent(pathname);
  let navigateHistory = rawPath.split('/').filter(item => item && item !== '');

  if (pathname.toLowerCase().replace(/\s+/g, '') === '/home' || pathname.toLowerCase().replace(/\s+/g, '') === '/my%20Profile') {
    return (
      <Typography className={classes.mainText} color={KenColors.ClientBlack2} fontSize={'1rem'} sx={{ fontWeight: "500 !important" }}>
        Welcome {userData.name} !
      </Typography>
    );
  }

  const cleanBreadcrumbs = [...navigateHistory];
  const originalFullPath = [...navigateHistory];

  for (let i = 0; i < cleanBreadcrumbs.length; i++) {
    const current = cleanBreadcrumbs[i];
    const prev = i > 0 ? cleanBreadcrumbs[i - 1] : '';

    const isIDAfterSpecificSegment =
      (prev === 'Student Details' ||
        prev === 'Student Info' ||
        prev === 'Session Attendance') &&
      (/^[a-zA-Z0-9-]+$/.test(current));

    if (isIDAfterSpecificSegment) {
      cleanBreadcrumbs.splice(i, 1);
      i--; 
    }
  }

  const isResourcesPath = pathname.endsWith('/Resources');
  
  const displayTitle = (pathname.includes('/My Students Faculty') || rawPath.includes('/My Students Faculty'))
    ? 'My Students' 
    : cleanBreadcrumbs[0];

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {isResourcesPath && (
          <IconButton onClick={() => navigate(-1)} size="small">
            <ArrowBackIcon />
          </IconButton>
        )}
        <Typography className={classes.mainText} color={KenColors.ClientBlack2} fontSize={'0.9375rem'}>
          {displayTitle}
        </Typography>
      </div>
      {cleanBreadcrumbs.length > 1 && (
        <Breadcrumbs separator={<Typography sx={{ fontSize: '0.75rem', fontWeight: '500' }}>&gt;</Typography>} style={{ color: '#3061FF' }}>
          {cleanBreadcrumbs.map((item, index) => {
            const isLastIndex = index === cleanBreadcrumbs.length - 1;

            let currentPathSegments = [];
            let segmentCounter = 0;

            for (let i = 0; i < originalFullPath.length; i++) {
              currentPathSegments.push(originalFullPath[i]);

              if (originalFullPath[i] === item && segmentCounter === index) {
                break;
              }

              const prev = i > 0 ? originalFullPath[i - 1] : '';
              const isIDSegment =
                (prev === 'Student Details' ||
                  prev === 'Student Info' ||
                  prev === 'Session Attendance') &&
                (/^[a-zA-Z0-9-]+$/.test(originalFullPath[i]));

              if (!isIDSegment) {
                segmentCounter++;
              }
            }

            const newPath = '/' + currentPathSegments.join('/');
            let displayItem = item.replace(/-/g, ' ');

            return index === cleanBreadcrumbs.length - 1 && state?.breadCrumbs ? (
              <Typography key={index} className={classes.listText} color={'#193389'} fontSize={'0.75rem'}>
                {state.breadCrumbs}
              </Typography>
            ) : (
              <Link key={index} className={classes.listText} to={newPath}>
                <Typography
                  sx={{
                    color: isLastIndex ? KenColors.ClientBlack2 : '#3061FF',
                    fontWeight: isLastIndex ? '400' : '600',
                    fontSize: '0.75rem'
                  }}
                >
                  {displayItem}
                </Typography>
              </Link>
            );
          })}
        </Breadcrumbs>
      )}
    </>
  );
};

export default AppBreadCrumbs;